module.exports = __webpack_public_path__ + "img/paybg.f980b47e.png";